import { render, staticRenderFns } from "./BeaconList.vue?vue&type=template&id=475866e9&scoped=true"
import script from "./BeaconList.vue?vue&type=script&lang=js"
export * from "./BeaconList.vue?vue&type=script&lang=js"
import style0 from "./BeaconList.vue?vue&type=style&index=0&id=475866e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475866e9",
  null
  
)

export default component.exports